import { useParams } from 'react-router-dom'
import { useCallback, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'

import { courseStore } from '@/stores/course.store'
import { institutionStore } from '@/stores/institution.store'

import { Course } from '@/domain/entities/course.entity'
import { Institution } from '@/domain/entities/institution.entity'
import { IInstitutionsService } from '@/services/contracts/institutions'

type ListInstitutionsProps = {
  institutionsService: IInstitutionsService
}

export function useListInstitution({
  institutionsService,
}: ListInstitutionsProps) {
  const { id } = useParams()
  const { setInstitution } = institutionStore()
  const { setCourses } = courseStore()
  const listInstitution = () => institutionsService.listById(id)

  const saveOnStorage = useCallback(
    (institution: Institution) => setInstitution(institution),
    [],
  )

  const saveCourseOnStorage = useCallback(
    (course: Course[]) => setCourses(course),
    [],
  )

  const {
    data,
    error: institutionsError,
    isFetching: isLoadingInstitution,
  } = useQuery({
    queryKey: [`list_institution`, id],
    staleTime: 1000 * 60 * 5,
    placeholderData: [{ institution: {} as Institution, courses: [] }, null],
    queryFn: listInstitution,
  })

  const [response, error] = data

  useEffect(() => {
    if (response?.institution) saveOnStorage(response.institution)
    if (response?.courses) saveCourseOnStorage(response.courses)
  }, [response])

  return {
    institution: response?.institution,
    courses: response?.courses,
    institutionsError: error || institutionsError,
    isLoadingInstitution,
  }
}
